<div class="white-border">
    <div class="ranking-bar flex items-center justify-center float-left relative cursor-pointer" (click)="openRaking()">
        <span class="ranking-position" *ngIf="rankingPosition && rankingPosition > 0">{{rankingPosition}}°</span>
        <span class="ranking-position" *ngIf="!rankingPosition || rankingPosition < 0">-</span>
        <img src="/assets/img/new-hud/medal.svg" alt="Ranking" class="absolute z-10 medal-img">
    </div>
</div>